import clearCanvasOverlay from '@/components/ProductProfile/utils/drawSection/clearCanvasOverlay'

export default function cleanAllTargetObjects() {
  const targetObjectNames = (window as any)?.threeViewer?.targetObjectNames
  targetObjectNames?.forEach((name: string) => {
    clearCanvasOverlay(name)
  })
}
